// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let DiagnosisV3Api = class DiagnosisV3Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Gets the specified diagnosis identifier.
     * @param diagnosisId
     */
    async diagnosisGet(diagnosisId) {
        const _url_ = '/diagnosis/v3/Diagnosis/{diagnosisId}'
            .replace('{' + 'diagnosisId' + '}', encodeURIComponent(String(diagnosisId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'diagnosisId' is not null or undefined
        if (diagnosisId === null || diagnosisId === undefined) {
            throw new Error('Required parameter diagnosisId was null or undefined when calling diagnosisGet.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DiagnosisModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Posts the specified request model.
     * @param DiagnosisSearchRequestModel
     */
    async diagnosisSearch(DiagnosisSearchRequestModel) {
        const _url_ = '/diagnosis/v3/DiagnosisSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'DiagnosisSearchRequestModel' is not null or undefined
        if (DiagnosisSearchRequestModel === null || DiagnosisSearchRequestModel === undefined) {
            throw new Error('Required parameter DiagnosisSearchRequestModel was null or undefined when calling diagnosisSearch.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(DiagnosisSearchRequestModel, "DiagnosisSearchRequestModel"),
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DiagnosisSearchModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get Diagnosis List
     * @param x_program_id The program id from the list of allowed program ids
     */
    async programDiagnosisGetByProgramId(x_program_id) {
        const _url_ = '/diagnosis/v3/ProgramDiagnosis';
        let _params_ = {};
        let _headers_ = {};
        _headers_['x-program-id'] = Serializer.serialize(x_program_id, "number");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DiagnosisModels");
        }
        return response;
    }
    /**
     *
     * @summary Get Diagnosis records associated with a Session
     * @param sessionId Session ID
     */
    async sessionDiagnosisGet(sessionId) {
        const _url_ = '/diagnosis/v3/SessionDiagnosis/{sessionId}'
            .replace('{' + 'sessionId' + '}', encodeURIComponent(String(sessionId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'sessionId' is not null or undefined
        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling sessionDiagnosisGet.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DiagnosisModels");
        }
        return response;
    }
};
DiagnosisV3Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], DiagnosisV3Api);
export { DiagnosisV3Api };
//# sourceMappingURL=diagnosisV3Api.js.map